
export const readFile = (file) => {
  // eslint-disable-next-line no-unused-vars
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onloadend = () => resolve(fileReader.result)
    return fileReader.readAsArrayBuffer(file)
  })
}

export const uploadFile = (url, fileType, rawFile) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open("PUT", url, true)
    // this fix issue type csv on window is 'application/vnd.ms-excel'
    const fileTypeHeader = fileType == 'application/vnd.ms-excel' ? 'text/csv' : fileType;
    xhr.setRequestHeader("Content-Type", fileTypeHeader);
    xhr.onload = function() {
      this.status === 200 || this.status === 204 ? resolve() : reject(this.responseText)
    }

    return xhr.send(rawFile)
  })
}

export const allowedTypes = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "text/csv"
]
